import { CourierSummaryRequest, ShipmentListRequest, PickupShipmentRequest, CourierListRequest } from "@/data/payload/api/PickupDashboardRequests";

import { RequestListSummary, RequestTabsList } from "@/domain/entities/PickupDashboardSummary";

// import { RequestTabsList } from "@/domain/entities/PickupDashboardSummary";
import { TransferPickupListRequest } from "@/domain/entities/PickupDashboard";

export class PickupDashboardEndpoint {
  getTabsList(params: RequestTabsList) {
    return `/hydra/v1/dashboard-pickup/shipment/summary?${params.toQueryString()}`;
  }
  getCourierSummary(params: CourierSummaryRequest): string {
    return `/hydra/v1/dashboard-pickup/shipment/summary?${params.toQueryString()}`;
  }
  getShipmentList(params: ShipmentListRequest): string {
    return `/hydra/v1/dashboard-pickup/shipment?${params.toQueryString()}`;
  }
  
  getAvailableCouriers(taskGroupIds?: string, q?: string): string {
    const baseUrl = "/hydra/v1/dashboard-pickup/courier-transfer";
    return taskGroupIds
      ? `${baseUrl}?q=${encodeURIComponent(
          q || ""
        )}&task_group_id=${taskGroupIds}`
      : q
      ? `${baseUrl}?q=${encodeURIComponent(
          q || ""
        )}&task_group_id=${taskGroupIds}&limit=50`
      : baseUrl;
  }

  transferPickup(): string {
    return "/hydra/v1/dashboard-pickup/transfer";
  }
  

  getSenderList(params: TransferPickupListRequest): string {
    return `/hydra/v1/dashboard-pickup/shipment?${params.toQueryString()}`;
  }
  
  export() {
    return "/hydra/v1/dashboard-pickup/export";
  }
  getListSummary(params: RequestListSummary) {
    return `/hydra/v1/dashboard-pickup/shipment?${params.toQueryString()}`
  }
  
  getBookingEligibleShipments(params: PickupShipmentRequest) {
    return `/hydra/v1/dashboard-pickup/shipment?${params.toQueryString()}`;
  }

  getCourierList(params: CourierListRequest) {
    return `/hydra/v1/dashboard-pickup?${params.toQueryString()}`;
  }

  manualAssign() {
    return "/hydra/v1/dashboard-pickup/assign";
  }
}